export class SynapiSelection {
    description?: any;
    count: number;
    Children?: any;
    id: string;
    name: string;
}
